import React from 'react';
import { Tag } from 'antd';

export const conApps = (leng, ind) => {
    return [
        {
            title: () => {
                return (
                    <>
                        App Name <Tag color="processing">{leng}</Tag>
                    </>
                );
            },
            dataIndex: 'app_name',
            key: 'app_name',
            fixed: 'left',
            sorter: (a, b) => (a.app_name ? a.app_name.localeCompare(b.app_name) : 1),
            // responsive: ["sm"],
            width: '17%',
        },
        {
            title: 'Categories',
            dataIndex: 'category',
            key: 'category',
            fixed: 'left',
            width: '11%',
        },
        {
            title: 'Activities',
            dataIndex: 'activities',
            key: 'activities',
            fixed: 'left',
            width: '12%',
        },
        {
            title: 'Platform',
            dataIndex: 'platforms',
            key: 'platforms',
            fixed: 'left',
            width: '10%',
        },
        {
            title: 'Release',
            dataIndex: 'release_version',
            key: 'release_version',
            fixed: 'left',
            width: '8%',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            fixed: 'left',
            width: '22%',
            render: (text) => {
                return (
                    <>
                        {text
                            ? text.split('|').map((item, index) => (
                                  <div key={index}>{item.trim()}</div> // Trims spaces around each item
                              ))
                            : ''}
                    </>
                );
            },
        },
        {
            title: 'Notification Date',
            dataIndex: 'announcement_date',
            key: 'announcement_date',
            fixed: 'left',
            sorter: (a, b) => new Date(a.announcement_date) - new Date(b.announcement_date),
            width: '9%',
            render: (text) => {
                return (
                    <>
                        {text
                            ? new Date(text).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                              })
                            : ''}
                    </>
                );
            },
        },
        {
            title: ind,
            dataIndex: 'scheduled_date',
            key: 'scheduled_date',
            fixed: 'left',
            width: '10%',
            defaultSortOrder: 'descend',
            sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
            render: (text) => {
                return (
                    <>
                        {text
                            ? new Date(text).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                              })
                            : ''}
                    </>
                );
            },
        },
    ];
};

export const trafficApps = (leng, ind) => {
    return [
        {
            title: () => {
                return (
                    <>
                        App Name <Tag color="processing">{leng}</Tag>
                    </>
                );
            },
            dataIndex: 'app_name',
            key: 'app_name',
            fixed: 'left',
            sorter: (a, b) => (a.app_name ? a.app_name.localeCompare(b.app_name) : 1),
            width: '15%',
        },
        {
            title: 'Categories',
            dataIndex: 'category',
            key: 'category',
            fixed: 'left',
            width: '10%',
        },
        {
            title: 'Activities',
            dataIndex: 'activities',
            key: 'activities',
            fixed: 'left',
            width: '11%',
        },
        {
            title: 'Platform',
            dataIndex: 'platforms',
            key: 'platforms',
            fixed: 'left',
            width: '8%',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            fixed: 'left',
            width: '26%',
        },
        {
            title: 'Notification Date',
            dataIndex: 'announcement_date',
            key: 'announcement_date',
            fixed: 'left',
            sorter: (a, b) => new Date(a.announcement_date) - new Date(b.announcement_date),
            width: '11%',
            render: (text) => {
                return (
                    <>
                        {text
                            ? new Date(text).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                              })
                            : ''}
                    </>
                );
            },
        },
        {
            title: 'Scheduled Date',
            dataIndex: 'scheduled_date',
            key: 'scheduled_date',
            fixed: 'left',
            sorter: (a, b) => new Date(a.scheduled_date) - new Date(b.scheduled_date),
            width: '8%',
            hidden: ind !== 'Scheduled Date',
            render: (text) =>
                text
                    ? new Date(text).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                      })
                    : '',
        },
        {
            title: 'Tentative Schedule',
            dataIndex: 'tentative_fix_date',
            key: 'tentative_fix_date',
            fixed: 'left',
            sorter: (a, b) => new Date(a.tentative_fix_date) - new Date(b.tentative_fix_date),
            defaultSortOrder: 'descend',
            width: '12%',
            render: (text) => {
                return (
                    <>
                        {text
                            ? new Date(text).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric',
                              })
                            : ''}
                    </>
                );
            },
        },
    ];
};

export const tabPageCss = {
    padding: '0',
    marginBottom: '0',
};

export const cardCss = { padding: '0', borderStyle: 'hidden' };
